export function toOxfordComma(array: string[]) {
	return array.length === 2
		? array.join(" and ")
		: array.length > 2
		? array
				.slice(0, array.length - 1)
				.concat(`and ${array.slice(-1)}`)
				.join(", ")
		: array.join(", ");
}
